var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header'),_c('iframe',{staticClass:"tables-v2-iframe",attrs:{"src":_vm.tablesV2Url,"title":"Database Tables V2","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }